import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import classNames from 'classnames';
import { api } from '@bilibili-maoer/web-utils';
import { prependPrefix } from '../utils/style.js';

var _loadingImageMap;
var ELoadingType;

(function (ELoadingType) {
  /**
   * 小猫走路
   */
  ELoadingType["Cat"] = "cat";
  /**
   * 小猫走路（夜间模式）
   */

  ELoadingType["CatDark"] = "cat-dark";
  /**
   * 像素 M 娘
   */

  ELoadingType["MGirl"] = "mgirl";
})(ELoadingType || (ELoadingType = {}));

var LOADING_IMG_URL_PREFIX = "".concat(api.removeUrlProtocol(api.MISSEVAN_CDN_PREFIX_URL), "/assets/images/loading");
var loadingImageMap = (_loadingImageMap = {}, _defineProperty(_loadingImageMap, ELoadingType.Cat, "".concat(LOADING_IMG_URL_PREFIX, "/cat.png")), _defineProperty(_loadingImageMap, ELoadingType.CatDark, "".concat(LOADING_IMG_URL_PREFIX, "/cat-dark.png")), _defineProperty(_loadingImageMap, ELoadingType.MGirl, "".concat(LOADING_IMG_URL_PREFIX, "/mgirl.gif")), _loadingImageMap);
var Loading = function Loading(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? ELoadingType.Cat : _ref$type,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prependPrefix('loading'), type, className),
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    src: loadingImageMap[type]
  }));
};

export { ELoadingType, Loading };
